import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type DestinationCounterProps = {
  className: string;
  label: string;
  value: string;
};

export const DestinationCounter: FC<DestinationCounterProps> = ({ className, label, value }) => {
  return (
    <div className='m-2'>
      <div>
        <span className={twMerge(`inline-block w-3 h-3 rounded-full mr-2 bg-success-400`, className)}></span>
        {label}
      </div>
      <div className='text-xl font-bold ml-5'>{value}</div>
    </div>
  );
};
